// extracted by mini-css-extract-plugin
module.exports = {"product-list-module__title":"ProductListModule_product-list-module__title__FzkAN","product-list-module__cta":"ProductListModule_product-list-module__cta__lxCDg"};